var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.839844,
    y: 0.117188,
    width: 35.9998,
    height: 36,
    rx: 17.9999,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 24H14.5652L18.4045 19.4869L21.3478 24H24.08H24.8627L24.4404 23.341L20.454 17.1193L25 12H23.4348L19.83 16.1455L17.1739 12H14.3085H13.5217L13.9515 12.659L17.7702 18.5143L13 24ZM18.2198 17.9972L14.7384 12.659H16.8135L19.3794 16.6637L23.6577 23.341H21.7048L18.2198 17.9972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.cbed47883ac13743f4d07b8e38411834.svg";
export { ForwardRef as ReactComponent };